import { createContext } from 'react';
export const SupportsUnifiedComputerComposerContext = createContext(false);
//# sourceMappingURL=SupportsUnifiedComputerComposerContext.js.map